export default __webpack_public_path__ + "static/media/pvilla4-4.2906e251.webp";